import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/explore/$")({
  beforeLoad: ({ search }) => {
    throw redirect({ search, to: "/explore" });
  },
});
